export default __webpack_public_path__ + "static/bubble-with-negative-values-2d3f33946da2d7360daad3e19b2765f8.png";